import { render, staticRenderFns } from "./creatRoster.vue?vue&type=template&id=430117fc&scoped=true&"
import script from "./creatRoster.vue?vue&type=script&lang=ts&"
export * from "./creatRoster.vue?vue&type=script&lang=ts&"
import style0 from "./creatRoster.vue?vue&type=style&index=0&id=430117fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430117fc",
  null
  
)

export default component.exports